export default "__VITE_ASSET__D371ilsv__"